import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=693c7adc"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=693c7adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports